import React, { useState } from 'react';
type TriageState = {
  prompt: string;
  n: string;
  hot: boolean;
  verdict: React.ReactNode;
  width: string;
  cap: string;
};
const STATES: TriageState[] = [{
  prompt: '\u201cwhat\u2019s the capital of France?\u201d',
  n: '0',
  hot: false,
  verdict: <>
        Retrieve it.
        <br data-id="element-315" data-mp="p2rt0xz9lxjv" />
        Display it.
      </>,
  width: '0%',
  cap: 'Nothing to govern'
}, {
  prompt: '\u201cdraft the response to the FDA letter\u201d',
  n: '7',
  hot: true,
  verdict: <>
        This one commits.
        <br data-id="element-316" data-mp="1hsqdeg2il6i7" />
        Seven things must hold.
      </>,
  width: '70%',
  cap: 'The obligations ride first, before attention decays'
}];
export function Triage() {
  const [active, setActive] = useState(0);
  const state = STATES[active];
  return <div className="triage" id="triage" data-id="element-317" data-mp="25gqcq4dw658e">
      <div className="hint" data-id="element-318" data-mp="25ht0i3fx3rk3">Click a prompt</div>
      {STATES.map((s, i) => <button type="button" key={s.prompt} className={`tq${i === active ? ' act' : ''}`} aria-pressed={i === active} onClick={() => setActive(i)} data-id="element-319" data-mp="20n5c04kwyx5i" data-mpi={i}>
          {s.prompt}
        </button>)}
      <div className="tread" data-id="element-320" data-mp="17stpkjbkg9mw">
        <div data-id="element-321" data-mp="17rim6km193wb">
          <span className={`num${state.hot ? ' hot' : ''}`} data-id="element-322" data-mp="17pxud2r3rz25">{state.n}</span>
          <span className="unit" data-id="element-323" data-mp="1cpk6f8v7399d">additional obligations</span>
        </div>
        <div className="verdict" data-id="element-324" data-mp="yr3yjelljcpn">{state.verdict}</div>
      </div>
      <div className="tgauge" data-id="element-325" data-mp="12syzuj3j1q3f">
        <div className="track" data-id="element-326" data-mp="12t7d4c3kaxf5">
          <div className="fill" style={{
          width: state.width
        }} data-id="element-327" data-mp="12uie645mhr2k" />
        </div>
        <div className="ticks" data-id="element-328" data-mp="ou7miywho8gc">
          {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(t => <span key={t} data-id="element-329" data-mp="ttby1w6vyi9u">{t}</span>)}
        </div>
      </div>
      <div className="tcap" data-id="element-330" data-mp="2j7gswhtqndud">{state.cap}</div>
      <div className="tpunch" data-id="element-331" data-mp="2j7qiw5es9l02">Every instruction in your company lands somewhere on this line.</div>
    </div>;
}